import React, { useEffect, useState } from 'react';

export function CameraFeed({ videoRef, overlayRef, tracking, facePresent, streamRef, showMesh, onToggleMesh }) {
  // Reattach stream whenever the video element mounts or stream changes
  useEffect(() => {
    const video = videoRef.current;
    const stream = streamRef?.current;
    if (!video || !stream) return;
    if (video.srcObject !== stream) {
      video.srcObject = stream;
      video.play().catch(() => {});
    }
  });

  return (
    <div style={{ position:'relative', borderRadius:14, overflow:'hidden', background:'var(--surface2)', border:'1px solid var(--border)', aspectRatio:'16/9', maxHeight:'calc(100vh - 120px)' }}>
      <video ref={videoRef} autoPlay playsInline muted
        style={{ width:'100%', height:'100%', objectFit:'cover', display:'block', transform:'scaleX(-1)' }} />
      <canvas ref={overlayRef}
        style={{ position:'absolute', inset:0, width:'100%', height:'100%', pointerEvents:'none' }} />

      {!tracking && (
        <div style={{ position:'absolute', inset:0, display:'flex', flexDirection:'column', alignItems:'center', justifyContent:'center', gap:12, background:'rgba(255,255,255,0.92)' }}>
          <div style={{ fontSize:'2.8rem' }}>👁</div>
          <div style={{ fontSize:'0.8rem', color:'var(--muted)', fontFamily:"'Nunito',sans-serif" }}>Start tracking to begin</div>
        </div>
      )}

      {tracking && (
        <>
          {/* Face detected badge */}
          <div style={{ position:'absolute', top:10, right:10, display:'flex', alignItems:'center', gap:6, background:'rgba(255,255,255,0.85)', borderRadius:20, padding:'4px 11px', backdropFilter:'blur(8px)' }}>
            <div style={{ width:6, height:6, borderRadius:'50%', background: facePresent ? 'var(--energetic)' : 'var(--angry)', boxShadow:`0 0 6px ${facePresent?'var(--energetic)':'var(--angry)'}`, animation:'pulse 2s infinite' }} />
            <span style={{ fontSize:'0.62rem', color:'var(--muted)', fontFamily:"'Nunito',sans-serif" }}>{facePresent ? 'Face detected' : 'No face'}</span>
          </div>

          {/* Mesh toggle button */}
          <button
            onClick={onToggleMesh}
            title={showMesh ? 'Hide mesh' : 'Show mesh'}
            style={{ position:'absolute', top:10, left:10, background: showMesh ? 'rgba(12,184,160,0.15)' : 'rgba(255,255,255,0.85)', border:`1px solid ${showMesh?'var(--accent)':'rgba(0,0,0,0.12)'}`, borderRadius:8, padding:'5px 10px', cursor:'pointer', display:'flex', alignItems:'center', gap:5, backdropFilter:'blur(8px)', transition:'all 0.2s' }}>
            <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
              <polygon points="7,1 13,4.5 13,9.5 7,13 1,9.5 1,4.5" stroke={showMesh?'var(--accent)':'rgba(0,0,0,0.4)'} strokeWidth="1.2" fill="none"/>
              <line x1="7" y1="1" x2="7" y2="13" stroke={showMesh?'var(--accent)':'rgba(0,0,0,0.2)'} strokeWidth="0.8"/>
              <line x1="1" y1="4.5" x2="13" y2="9.5" stroke={showMesh?'var(--accent)':'rgba(0,0,0,0.2)'} strokeWidth="0.8"/>
              <line x1="13" y1="4.5" x2="1" y2="9.5" stroke={showMesh?'var(--accent)':'rgba(0,0,0,0.2)'} strokeWidth="0.8"/>
            </svg>
            <span style={{ fontSize:'0.6rem', color: showMesh?'var(--accent)':'rgba(0,0,0,0.45)', fontFamily:"'Nunito',sans-serif" }}>
              {showMesh ? 'Mesh on' : 'Mesh'}
            </span>
          </button>
        </>
      )}
    </div>
  );
}
